import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Cómo recibo el material?',
    a: 'Después del pago recibirás acceso inmediato al contenido digital completo.'
  }, {
    q: '¿Necesito experiencia en cocina?',
    a: 'No. Las recetas y planificaciones son simples y fáciles de aplicar.'
  }, {
    q: '¿El contenido sirve para niños y adultos?',
    a: 'Sí. El sistema incluye recomendaciones para todas las edades.'
  }, {
    q: '¿Las recetas son 100% sin gluten?',
    a: 'Sí. Todo el contenido está pensado para personas celíacas.'
  }, {
    q: '¿Esto reemplaza consultas médicas?',
    a: 'No. Siempre es importante mantener controles médicos y nutricionales adecuados.'
  }];
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="py-20 px-4" data-id="element-46">
      <div className="max-w-3xl mx-auto" data-id="element-47">
        <div className="text-center mb-12" data-id="element-48">
          <h2 className="font-serif text-4xl text-forest" data-id="element-49">
            PREGUNTAS FRECUENTES
          </h2>
        </div>

        <div className="space-y-4" data-id="element-50">
          {faqs.map((faq, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-warm-white rounded-2xl border border-sage/20 overflow-hidden" data-id="element-51">
              <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" data-id="element-52">
                <span className="font-serif text-lg text-forest font-medium pr-4" data-id="element-53">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-sage transition-transform duration-300 flex-shrink-0 ${openIdx === idx ? 'rotate-180' : ''}`} data-id="element-54" />
              </button>

              <AnimatePresence data-id="element-55">
                {openIdx === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-56">
                    <div className="px-6 pb-5 text-muted leading-relaxed" data-id="element-57">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}